import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from 'react-router'
import { GlobalLoadingIndicator } from '../common/GlobalLoadingIndicator'

// Flag on: a logged-out user hitting any page is sent straight to Auth0
// Universal Login (no intermediate Howie login page), preserving where they
// were headed via appState.returnTo. PD-27768.
export default function Auth0AutoRedirect() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0()
  const location = useLocation()

  useEffect(() => {
    if (isLoading || isAuthenticated) return
    loginWithRedirect({ appState: { returnTo: `${location.pathname}${location.search}` } })
  }, [isLoading, isAuthenticated, loginWithRedirect, location])

  return <GlobalLoadingIndicator isLoading />
}
